import { useQuery } from '@apollo/client';

import Folder from '@components/drive/Folder';
import HandleQuery from '@components/HandleQuery';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';
import useSubscribeToJourney from '@hooks/subscriptions/useSubscribeToJourney';
import {
  GetJourneyWithDocumentsDocument,
  GetJourneyWithDocumentsQuery,
  GetJourneyWithDocumentsQueryVariables
} from '@typing/Generated';

type Props = {
  folderId: string;
  journeyId: string;
};

const ExpertJourneyFolderPage = ({ folderId, journeyId }: Props) => {
  const getJourneyWithDocumentsQuery = useQuery<GetJourneyWithDocumentsQuery, GetJourneyWithDocumentsQueryVariables>(
    GetJourneyWithDocumentsDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  useSubscribeToJourney(journeyId, () => {
    getJourneyWithDocumentsQuery.refetch();
  });

  const folder = getJourneyWithDocumentsQuery.data?.journey.folders.find(folder => folder.id === folderId);

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.folder.show" journeyId={journeyId}>
      <HandleQuery query={getJourneyWithDocumentsQuery}>
        {data => <>{folder && <Folder folder={folder} journey={data.journey} />}</>}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyFolderPage;
